import React from "react";
import RightIconSVG from "../../../components/svg/RightIconSVG";
import Controls from "../../../components/controls/control";

export default function AssignmentMarkListTr({
  row,
  handleMark,
  markValue,
  handleInputChange,
}) {
  const { id, title, createdAt, student_name, repo_link, mark, status } =
    row || {};
  const showMark = status === "published";
  let markContent = null;
  markContent = showMark ? (
    mark
  ) : (
    <>
      <Controls.Input
        name={`mark_${id}`}
        value={markValue[`mark_${id}`]}
        onChange={(e) => handleInputChange(e, id)}
      />
      <RightIconSVG onClick={() => handleMark(id)} />
    </>
  );
  return (
    <tr>
      <td className="table-td">{title}</td>
      <td className="table-td">{createdAt}</td>
      <td className="table-td">{student_name}</td>
      <td className="table-td">{repo_link}</td>
      <td className={`table-td ${!showMark && "input-mark"}`}>{markContent}</td>
    </tr>
  );
}
